import Layout from "../../../../src/components/layout";
import SEO from "../../../../src/components/seo";
import ActionCard from "../../../../src/components/action-card";
import ActionList from "../../../../src/components/action-list";
import data from "../../../../src/data/home-actions";
import * as React from 'react';
export default {
  Layout,
  SEO,
  ActionCard,
  ActionList,
  data,
  React
};